export default __webpack_public_path__ + "static/fast-load-93b31d11b0e2080255889a19eb42fd3e.mp4";